import { render, staticRenderFns } from "./Step-2.vue?vue&type=template&id=35e3babf&scoped=true&"
import script from "./Step-2.vue?vue&type=script&lang=js&"
export * from "./Step-2.vue?vue&type=script&lang=js&"
import style0 from "./Step-2.vue?vue&type=style&index=0&id=35e3babf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e3babf",
  null
  
)

export default component.exports